<template>
  <div class=" ">
    <div class="text-56 roboto-medium-black-48px">
      <span class="roboto-medium-black-48px">Say hello! 👋</span>
      <div class="text-58 roboto-medium-black-48px">
        We are about to collaborate soon.
      </div>
    </div>
  

    <div class="frame-1729 border-1px-desert-storm">
      <form
        class="flex-col"
        @submit.prevent="contactServices"
      >
        <div class="input-2">
          <div class="your-name worksans-normal-fiord-16px">
            Your name
          </div>
          <input
            v-model.trim="name"
            type="text"
            autocomplete="true"
            required
            class="input border-1px-mischka"
            placeholder="Enter your name"
          >
        </div>
        <div class="input-1">
          <div class="your-mobile worksans-normal-fiord-16px">
            Your mobile
          </div>
          <input
            v-model.trim="contactnumber"
            type="text"
            autocomplete="true"
            required
            class="input border-1px-mischka"
            placeholder="Eg. 12345679"
          >
        </div>
        <div class="input-1">
          <div class="your-email worksans-normal-fiord-16px">
            Your email
          </div>
          <input
            v-model.trim="youremail"
            type="email"
            autocomplete="true"
            required
            class="input border-1px-mischka"
            placeholder="Please enter your email id"
          >
        </div>
        <div class="input-1">
          <div class="message worksans-normal-fiord-16px">
            Message
          </div>
          <textarea
            v-model.trim="message"
            type="text"
            autocomplete="true"
            required
            class="input-3 border-1px-mischka"
            placeholder=" Eg: Write a brief about your query"
          />
        </div>

        <div class="accept_terms">
          <label class="container">
            <p class="flex">
              <span
                class="worksans-normal-granite-gray-12px"
              >I hereby give my constent to Djuli</span><span class="worksans-normal-mirage-12px">&nbsp;</span><span
                class="worksans-normal-mountain-meadow-12px"
              >to store my data</span><span class="worksans-normal-mirage-12px">&nbsp;</span><span class="worksans-normal-mirage-12px">&nbsp;</span><span
                class="worksans-normal-granite-gray-12px"
              >so they can respond to my inquiry.</span>
            </p>
            <input
              id="terms"
              v-model="consent"
              type="checkbox"
              class=""
              required
            >
            <span class="checkmark" />
          </label>
        </div>
        <div class="frame-13">
          <button
            class="
              button
              border
              cancel
              roboto-medium-mountain-meadow-18px
            "
            @click="router.push('/navigation')"
          >
            Cancel
          </button>
          <button
            class="button-1 submit roboto-medium-white-lilac-18px"
            type="submit"
            :disable="consent"
          >
            Submit
          </button>
        </div>
      </form>
      <div class="flex-col-1">
        <div class="group-1976">
          <div class="reach-us worksans-medium-licorice-18px">
            Reach us
          </div>
          <p class="text-4 worksans-normal-granite-gray-16px">
            Djuli,<br>Zimmer &amp; Peacock AS - Bygg 24,<br>Nedre vei 8,<br>3183
            Horten, Norway
          </p>
          <div
            class="directions worksans-normal-mountain-meadow-12px"
            @click="showDirections"
          >
            Directions
          </div>
        </div>
        <div class="group-1977">
          <div class="email worksans-medium-licorice-18px">
            Email
          </div>
          <a
            href="mailto:djuli@zimmerpeacock.com"
            target="_blank"
          ><div class="text-5 worksans-normal-granite-gray-16px">
            djuli@zimmerpeacock.com
          </div></a>
        </div>
      </div>
    </div>
    <teleport to="body">
      <div
        v-if="loader"
        class="loading_log"
      >
        <spin-loading
          loadingstatus=""
          loadingmessage=""
        />
      </div>
    </teleport>
  </div>
</template>

<script>
import SpinLoading from '../SpinLoading'
import { mapActions } from 'vuex';

export default {
  components:{
    SpinLoading
  },
  data() {
    return {
      loader:false,
      name: null,
      contactnumber: null,
      youremail: null,
      message: null,
      consent: false,
      errormessage: null,
      successmessage: null,
    };
  },
  methods: {
    ...mapActions({
      submitQuery: 'contactquery/submitQuery',
      showDirections: 'constants/showDirections',
    }),
    async contactServices() {
      try{
        this.loader = true
        let contactPayload = {
          name: this.name,
          youremail: this.youremail,
          contactnumber: this.contactnumber,
          message: this.message,
          consent: this.consent,
        };
        const successContact = await this.submitQuery(contactPayload);
        if(successContact){
          this.$alert(
            'Query is well received. You will hear from us soon.',
            'Success',
            'success',
          )
          this.name=''
          this.youremail=''
          this.contactnumber=''
          this.message=''
          this.consent=false
        }else{
          throw 'Not success'
        }
      }catch{
        this.$alert(
            'Error while submitting the query. Please verify your internet connection and try again.',
            'Error',
            'info',
          )
      }finally{
        this.loader = false
      }
    },
  },
};
</script>

<style scoped>
button {
  background-color: none;
  border: none;
}
.input::placeholder,
.input-3::placeholder {
  letter-spacing: 0;
  min-height: 14px;
  color: var(--pewter-blue);
  font-family: var(--font-family-work_sans);
  font-size: var(--font-size-xs);
  font-style: normal;
  font-weight: 400;
}

.input:focus,
.input-3:focus {
  outline: none;
  border-color: var(--djuli-primary-color);
}

a {
  text-decoration: none;
}
.text-58 {
  margin-top: 0.5rem;
}
.contact {
  background-color: var(--white);
  height: 1056px;
  position: relative;
  width: 100vw;
  margin-top: 2rem;
}

.text-56 {
    /* left: 356px; */
    /* letter-spacing: 0; */
    /* position: absolute; */
    text-align: center;
    /* top: 8rem; */
    margin: auto;
    /* width: 100vw; */
    padding-top: 4rem;
}

.text-57 {
  /* left: 626px; */
  letter-spacing: 0;
  line-height: 27px;
  position: absolute;
  /* text-align: center; */
  top: 16rem;
  display: flex;
  margin: auto;
  width: 100vw;
  justify-content: center;
}

.frame-1729 {
align-items: flex-start;
    background-color: var(--white);
    border-radius: 8px;
    display: flex;
    /* height: 626px; */
    overflow: hidden;
    /* padding: 28px 255px; */
    width: 100vw;
    display: flex;
    justify-content: space-around;
    /* position: relative; */
    /* top: 20rem; */
    padding-top: 5rem;
}


.flex-col {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  min-height: 534px;
  width: auto;
}

.input-2 {
  align-items: flex-start;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  margin-left: 0;
  min-height: 76px;
  width: 441px;
}

.your-name {
  letter-spacing: 0;
  line-height: 24px;
  min-height: 24px;
  white-space: nowrap;
}

.input {
  align-items: flex-end;
  background-color: var(--white);
  border-radius: 4px;
  display: flex;
  height: 52px;
  overflow: hidden;
  padding: 17px 16px;
  width: 462px;
}

.text-1 {
  letter-spacing: 0;
  min-height: 14px;
  min-width: 141px;
}

.input-1 {
  align-items: flex-start;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  margin-left: 0;
  margin-top: 16px;
  min-height: 76px;
  width: 441px;
}

.your-mobile {
  letter-spacing: 0;
  line-height: 24px;
  min-height: 24px;
  white-space: nowrap;
}

.eg-9876543210 {
  letter-spacing: 0;
  min-height: 14px;
  min-width: 93px;
}

.your-email {
  letter-spacing: 0;
  line-height: 24px;
  min-height: 24px;
  white-space: nowrap;
}

.text-2 {
  letter-spacing: 0;
  min-height: 14px;
  min-width: 178px;
}

.message {
  letter-spacing: 0;
  line-height: 24px;
  min-height: 24px;
  white-space: nowrap;
}

.input-3 {
  align-items: flex-start;
  background-color: var(--white);
  border-radius: 4px;
  display: flex;
  height: 100px;
  overflow: hidden;
  padding: 14px 16px;
  width: 462px;
  resize: none;
}

.text-3 {
  letter-spacing: 0;
  min-height: 14px;
}

.checkbox {
  align-items: center;
  display: flex;
  height: 28px;
  margin-top: 25px;
  min-width: 462px;
}

.icon {
  align-items: flex-start;
  display: flex;
  height: 20px;
  padding: 1.5px;
  width: auto;
  padding-top: 1rem;
}
.check_icon {
  height: 12px;
  width: 15px;
}

.vector {
  height: 17px;
  width: 17px;
}

.list-item {
  letter-spacing: 0;
  margin-left: 8px;
  min-height: 28px;
  width: 436px;
}

.frame-13 {
  align-items: flex-start;
  display: flex;
  margin-left: 0;
  
  min-width: 204px;
}

.button {
  align-items: center;
  border-radius: 5px;
  display: flex;
  height: 49px;
  justify-content: flex-end;
  min-width: 96px;
  padding: 0 18px;
}

.cancel {
  letter-spacing: 0;
  min-height: 21px;
  min-width: 58px;
  text-align: center;
}

.button-1 {
  align-items: center;
  background-color: var(--djuli-primary-color);
  border-radius: 5px;
  box-shadow: 0px 16px 24px #0000001f;
  display: flex;
  height: 49px;
  justify-content: flex-end;
  margin-left: 10px;
  min-width: 98px;
  padding: 0 18px;
}

.submit {
  letter-spacing: 0;
  min-height: 21px;
  min-width: 60px;
  text-align: center;
  text-shadow: 0px 16px 24px #0000001f;
}

.flex-col-1 {
  align-items: flex-start;
  align-self: center;
  display: flex;
  flex-direction: column;
  margin-bottom: 82px;
  margin-left: 5rem;
  min-height: 250px;
}

.group-1976 {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  min-height: 153px;
  width: 350px;
}

.reach-us {
  letter-spacing: 0;
  line-height: 27px;
  min-height: 27px;
  white-space: nowrap;
}

.text-4 {
  letter-spacing: 0;
  line-height: 24px;
  margin-top: 8px;
  min-height: 96px;
  width: 346px;
}

.directions {
  letter-spacing: 0;
  margin-top: 8px;
  min-height: 14px;
  cursor: pointer;
}

.group-1977 {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  margin-top: 38px;
  min-height: 59px;
  width: 215px;
}

.email {
  letter-spacing: 0;
  line-height: 27px;
  min-height: 27px;
  white-space: nowrap;
  text-decoration: none;
}

.text-5 {
  cursor: pointer;
  letter-spacing: 0;
  line-height: 24px;
  margin-top: 8px;
  min-height: 24px;
  white-space: nowrap;
  text-decoration: none;
}

.icon {
  align-items: flex-start;
  display: flex;
  height: 20px;
  padding: 2.5px;
  width: auto;
  margin-top: 0.5rem;
}
.check_icon {
  height: 12px;
  width: 15px;
}

.accept_terms {
  margin-top: 1.5rem;
}

.list-item {
  letter-spacing: 0;
  margin-left: 8px;
  min-height: 14px;
  min-width: 409px;
}

.container {
  display: block;
  position: relative;
  padding-left: 15px;

  cursor: pointer;

  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  width: 14px;
  height: 14px;
  border-radius: 20%;
  border: 1.25px solid #94a3b8;
}

.container input:checked ~ .checkmark {
  background-color: var(--djuli-primary-color);
  border: 1px solid var(--djuli-primary-color);
  border-radius: 20%;
  width: 14px;
  height: 14px;
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.container input:checked ~ .checkmark:after {
  display: block;
}

.container .checkmark:after {
  left: 4px;
  top: 1px;
  width: 4px;
  height: 8px;
  border: solid #ffffff;
  border-width: 0 1px 1px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.warning_icon {
  width: 1.5rem;
  margin-right: 10px;
}
.error-class {
  padding: 0.25rem;
  font-family: "Inter";
  background: darkslateblue;
  font-size: 12px;
  color: white;
  display: flex;
  font-weight: 600;
  flex-direction: row;
  align-items: center;
  width: 100%;
  border-radius: 5px;
  margin-top: 10px;
  opacity: 0.9;
}
</style>
